<mat-card>
  <mat-card-content>
    <div class="head-container">
      <h1>{{'subscription.heading' | translate}}</h1>
      <!-- <div (mouseover)="onTraningIcon(videoAssetGroups.Subscription)">
        <img class="trainingIcon" src="../../../assets/favicon/video.png">
      </div>
      <div class="popupHover">
        <ng-container *ngIf="isHidden">
          <div class="hideshow">
            <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
          </div>
        </ng-container>
      </div> -->
      <span class="spacer"></span>
      <span class="message" *ngIf="clientForm.get('creditsAvailable').value > 0 && clientForm.get('creditsAvailable').value <= perOfTestCredits">
        <strong>{{'subscription.warningMsg' | translate}}</strong></span>
      <span class="red" *ngIf="clientForm.get('creditsAvailable').value === 0"> <mat-icon>error</mat-icon><strong>{{'subscription.creditsConsumed' | translate}}</strong></span>
    </div>
    <form [formGroup]="clientForm">
      <div class="row">
        <div class="col-lg-4">
          <span>
            <b>{{'subscription.label1' | translate}}</b>
          </span>
          <input type="text" class="space" formControlName="totalTestCredits">
        </div>
        <div class="col-lg-4 text-center">
          <span>
            <b>{{'subscription.label2' | translate}}</b>
          </span>
          <input type="text" class="space" formControlName="creditsConsumed">
        </div>
        <div class="col-lg-4 text-right">
          <span>
            <b>{{'subscription.label3' | translate}}</b>
          </span>
          <input type="text" class="space" formControlName="creditsAvailable"
            [ngClass]="clientForm.get('totalTestCredits').value != 0 &&
            (clientForm.get('creditsAvailable').value  === 0   ? 'danger':clientForm.get('creditsAvailable').value >= 1 && clientForm.get('creditsAvailable').value <= perOfTestCredits ? 'warning' : '' )">
        </div>
      </div>
      <div class="head-container"></div>
    </form>
    <div class="tab-container">
      <mat-tab-group mat-align-tabs="end" animationDuration="0ms" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChanged($event)">
        <mat-tab label="{{'subscription.TabCreditUsage.label' | translate}}">
          <div *ngIf="selectedTabIndex == 0">
            <credits-usage>
            </credits-usage>
          </div>
        </mat-tab>
        <mat-tab label="{{'subscription.TabPurchaseHist.label' | translate}}">
          <div *ngIf="selectedTabIndex == 1">
            <purchase-history>
            </purchase-history>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-card-content>
</mat-card>
